/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseBreed
 */
export interface HorseBreed {
    /**
     * 
     * @type {number}
     * @memberof HorseBreed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof HorseBreed
     */
    shortcut?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseBreed
     */
    name?: string | null;
}

/**
 * Check if a given object implements the HorseBreed interface.
 */
export function instanceOfHorseBreed(value: object): value is HorseBreed {
    return true;
}

export function HorseBreedFromJSON(json: any): HorseBreed {
    return HorseBreedFromJSONTyped(json, false);
}

export function HorseBreedFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseBreed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'shortcut': json['shortcut'] == null ? undefined : json['shortcut'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function HorseBreedToJSON(json: any): HorseBreed {
    return HorseBreedToJSONTyped(json, false);
}

export function HorseBreedToJSONTyped(value?: HorseBreed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shortcut': value['shortcut'],
        'name': value['name'],
    };
}

